<template>
    <div class="MemberAreaContent">
        <contacts-panel :isOpen="isContactsOpen" @close="isContactsOpen = false"/>
        <div class="MemberAreaContent__middle">
            <discussion v-if="openedDiscussion" ref="discussion" @openPanel="handleOpenPanel"/>
            <new-discussion v-else @openPanel="handleOpenPanel"/>
        </div>
        <alerts-panel :isOpen="isAlertsOpen" @close="isAlertsOpen = false"/>
    </div>
</template>

<script>
    import NewDiscussion from "./NewDiscussion";
    import Discussion from "./Discussion";
    import {actions, getters, mutations} from "../../store";
    import MemberAreaNav from "../MemberAreaNav";
    import Contact from "./Contact";
    import AlertsPanel from "./AlertsPanel";
    import ContactsPanel from "./ContactsPanel";

    const audio = new Audio('/sounds/notification.mp3');

    export default {
        components: {ContactsPanel, Contact, AlertsPanel, MemberAreaNav, NewDiscussion, Discussion},
        data: function () {
            return {
                isContactsOpen: false,
                isAlertsOpen: false
            }
        },
        computed: {
            openedDiscussion: getters.openedDiscussion
        },
        methods: {
            handleOpenPanel: function (panel) {
                switch (panel) {
                    case 'alerts':
                        this.isAlertsOpen = !this.isAlertsOpen;
                        break;
                    case 'contacts':
                        this.isContactsOpen = !this.isContactsOpen;
                }
            }
        },
        async created() {
            mutations.closeDiscussion();
            if(!this.$users){
                await actions.fetchUser();
            }
            Echo.private(`User.${this.$user.id}`)
                .listen('DiscussionMessageSent', async (e) => {
                    let discussion = e.discussion;

                    await mutations.pushDiscussions({
                        ...discussion,
                        last_message: e.message
                    });

                    console.log(discussion);

                    if (e.message.user.id === this.$user.id) {
                        return;
                    } else if (this.openedDiscussion && discussion.id === this.openedDiscussion.id) {
                        this.$refs.discussion.scrollToBottom();
                        await actions.markAsRead(discussion.id);
                    } else {
                        if (audio.paused) {
                            await audio.play();
                        } else {
                            audio.currentTime = 0;
                        }
                    }
                });

            mutations.setSocketId(Echo.socketId());
        },
        beforeDestroy() {
            Echo.leave(`User.${this.$user.id}`);
            mutations.clearSocketId();
        }
    }
</script>
